import { InfoCard, type InfoCardProps } from '@/components/contracts/InfoCard'
import type { SalesTaxReportSummary } from '@/lib/services/reports/reports.types'
import { formatCurrency } from '@/lib/utils'
import { ArrowUpRight, Landmark, ReceiptText, ShieldMinus } from 'lucide-react'

type SalesTaxSummaryCard = Pick<
  InfoCardProps,
  'icon' | 'tone' | 'title' | 'description' | 'value'
> & {
  key: string
}

export function SalesTaxSummaryCards({ summary }: { summary: SalesTaxReportSummary }) {
  const summaryCards: SalesTaxSummaryCard[] = [
    {
      key: 'gross_taxable_sales',
      title: 'Taxable Amount',
      description: 'The total from your orders and refunds',
      value: formatCurrency(summary.gross_taxable_sales),
      icon: Landmark,
      tone: 'amethyst',
    },
    {
      key: 'untaxable_amount',
      title: 'Non-taxable Amount',
      description: 'Sales and refunds excluded from tax in this report',
      value: formatCurrency(summary.untaxable_amount),
      icon: ShieldMinus,
      tone: 'periwinkle',
    },
    {
      key: 'tax_collected',
      title: 'Tax Collected',
      description: 'The tax total from your orders and refunds',
      value: formatCurrency(summary.tax_collected),
      icon: ArrowUpRight,
      tone: 'periwinkle',
    },
    {
      key: 'transaction_count',
      title: 'Transaction Count',
      description: 'The number of transactions in this report',
      value: summary.transaction_count.toString(),
      icon: ReceiptText,
      tone: 'mint',
    },
  ]

  return (
    <div className="mb-4 grid grid-cols-1 gap-4 lg:grid-cols-4">
      {summaryCards.map((card) => (
        <InfoCard
          key={card.key}
          icon={card.icon}
          tone={card.tone}
          title={card.title}
          description={card.description}
          value={card.value}
        />
      ))}
    </div>
  )
}
